<template>
  <div class="col-span-2">
    <button
      id="contact-submit-button"
      @click="onContactSubmit"
      class="w-full shadow-green rounded-md items-center px-6 py-3 border border-transparent text-sm uppercase tracking-wider leading-normal font-bold text-white bg-green-300 hover:bg-indigo-400 focus:outline-none border-none focus:shadow-outline-indigo active:bg-indigo-400"
    >
      {{loading ? '' : 'Alusta suhtlust'}}
      <div v-if="loading" class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "ContactFormSubmit",
  props: ["loading"],

  methods: {
    onContactSubmit(e) {
      e.preventDefault();
      this.$emit("onContactSubmit");
    },
  },
};
</script>

<style scoped>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  left: -50px;
  top: -7px;
}

.lds-ellipsis div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
